export default __webpack_public_path__ + "static/media/pokemon_bug.f8f5ba30.png";